import {useTranslation} from "react-i18next";
import React from "react";
import {defaultDatePickerStrings, IDatePickerStrings, IToggleProps, Toggle} from "@fluentui/react";


export const ToggleDate = (props: IToggleProps) => {
  const {t, i18n } = useTranslation();
  return (<Toggle onText={t('date')} offText={t('cell')} {...props} />)
}
